import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import {
  BsBag,
  BsCapsulePill,
  BsCreditCard,
  BsHeartPulse,
  BsLightning,
} from "react-icons/bs";
import { CiPill } from "react-icons/ci";
import { FaBars, FaMapMarkerAlt } from "react-icons/fa";
import { FaArrowsRotate } from "react-icons/fa6";
import { IoNutritionOutline } from "react-icons/io5";
import { useHistory, Link } from "react-router-dom";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { HiMiniChevronDown } from "react-icons/hi2";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import Loader from "../elementsDS/Loaders/LoadContent";
import { TextButton } from "../elementsDS/buttons/Buttons";
import logo from "../../../logo.svg";
const Nav = styled.nav`
  border-bottom: 1px solid ${(props) => props.theme.colors.secondary};
  background: ${(props) => props.theme.colors.light};
  display: flex;
  justify-content: center;
  gap: 45px;
  align-items: center;
  position: relative;
  padding-left: 200px;
  padding-right: 200px;
  @media (max-width: 1080px) {
      padding: 0px;
    };
  @media (max-width: 1020px) {
      gap:0px;
    };
  @media (max-width: 768px) {
  height:60px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0px;
    border: 0;
    padding-bottom: 0px;
    // background: transparent;
    }
  }
`;

const LinkwoUnderline = styled(Link)`
  text-decoration: none;
`;

const NavItem = styled.li`
  list-style: none;
  padding: 10px;
  cursor: pointer;
  color: ${(props) => props.theme.colors.primary};
  /* TextRegular/Paragraph */
  font-family: ${(props) => props.theme.typography.fontFamily};
  position: relative;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
  display: flex;
  border-radius: 8px;
  gap: 10px;
  align-items: center;
  &:hover {
    background-color: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.light};
    transition: width 2s linear 1s;
    @media (max-width: 768px) {
      background-color: transparent;
      color: ${(props) => props.theme.colors.secondary};
    }
  }
  @media only screen and (min-device-width: 768px) and (max-device-width: 1366px) {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    color: ${(props) => props.theme.colors.primaryDeep};
    background-color: ${(props) => props.theme.colors.light};
  }
`;

const SubMenu = styled.ul`
  background-color: ${(props) => props.theme.colors.primary};
  position: absolute;
  color: ${(props) => props.theme.colors.light};
  display: none;
  padding: 3px;
  list-style: none;
  width: 260px;
  left: 0;
  top: 30px;
  z-index: 1000;
  min-height: 60vh;
  ${NavItem}:hover & {
    display: block;
    color: ${(props) => props.theme.colors.light};
    box-shadow: 0px 5px 7px 0px rgba(17, 18, 73, 0.5);
  }
  @media (max-width: 768px) {
    position: static;
    display: none;
    overflow-y: scroll;
    width: auto;
    min-height: auto;
    margin-top: 10px;
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.light};
  }
`;

const SubMenuItem = styled.li`
  padding: 10px 16px;
  text-align: left;
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.light};
  &:hover {
    background-color: ${(props) => props.theme.colors.secondary};
    @media (max-width: 768px) {
      background-color: transparent;
      color: ${(props) => props.theme.colors.secondary};
    }
  }
  @media (max-width: 768px) {
    font-size: 12px;
    text-wrap: wrap;
    padding: 5px 10px;
    background-color: ${(props) => props.theme.colors.light};
    color: ${(props) => props.theme.colors.primary};
  }
`;

const SubMenu2Item = styled.li`
  padding: 10px 16px;
  text-align: left;
  &:hover {
    background-color: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.light};
    @media (max-width: 768px) {
      background-color: ${(props) => props.theme.colors.secondary};
      color: ${(props) => props.theme.colors.tertiary};
      font-weight: 700;
    }
  }
  @media (max-width: 768px) {
    font-size: 12px;
    text-wrap: wrap;
    padding: 5px 10px;
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.light};
  }
`;

const SubMenu2 = styled.ul`
  left: 200px;
  top: 0px;
  display: none;
  background-color: ${(props) => props.theme.colors.primary};
  position: absolute;
  padding: 3px;
  list-style: none;
  z-index: 1;
  height: auto;
  max-height: 60vh;
  overflow: auto;
  width: 349px;
  ${SubMenuItem}:hover & {
    display: block;
    background: ${(props) => props.theme.colors.primary};
    box-shadow: 0px 5px 7px 0px rgba(17, 18, 73, 0.5);
    @media (max-width: 768px) {
      color: ${(props) => props.theme.colors.primary};
      background-color: ${(props) => props.theme.colors.light};
    }
  }
  @media (max-width: 768px) {
    position: static;
    display: none;
    width: auto;
    color: ${(props) => props.theme.colors.primary};
    background-color: ${(props) => props.theme.colors.light};
    overflow-y: scroll;
    min-height: auto;
    margin-top: 10px;
  }
`;

const SubMenu3 = styled.ul`
  background-color: ${(props) => props.theme.colors.light};
  position: absolute;
  width: auto;
  left: 200px;
  top: 0px;
  display: none;
  padding: 3px;
  list-style: none;
  z-index: 1;
  height: 60vh;
  ${SubMenu2Item}:hover & {
    display: block;
    background: ${(props) => props.theme.colors.primary};
    box-shadow: 0px 5px 7px 0px rgba(17, 18, 73, 0.5);
  }
  @media (max-width: 768px) {
    position: static;
    display: none;
    width: auto;
    color: ${(props) => props.theme.colors.primary};
    overflow-y: scroll;
    min-height: auto;
    margin-top: 10px;
  }
`;

const MenuIcon = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 10px;
    padding: 5px 6px 5px 6px;
    margin-left: 10px;
    border-radius: 8px;
    color: ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.light};
    &:hover {
      background: ${(props) => props.theme.colors.secondary};
      color: ${(props) => props.theme.colors.light};
    }
  }
`;

const ImageIcon = styled.img`
width: 120px;
  @media (max-width: 768px) {
    cursor: pointer;
    position: absolute;
    right: 29px;
    width: 60px;
    color: ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.light};
    &:hover {
      background: ${(props) => props.theme.colors.secondary};
      color: ${(props) => props.theme.colors.light};
    }
  }
`;

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.light};
  // width: 250px;
  min-height: 100vh;
  padding: 6px;
  position: fixed;
  top: 0;
  left: ${({ isOpen }) => (isOpen ? "0" : "-250px")};
  transition: left 0.3s ease-in-out;
  z-index: 1030;
  box-shadow: 0px 5px 7px 0px rgba(208, 207, 207, 0.6);
  @media (max-width: 768px) {
    width: 200px;
    background-color: ${(props) => props.theme.colors.light};
    color: ${(props) => props.theme.colors.primary};
  }
`;

const MobileNavItem = styled.li`
  display: none;
  @media (max-width: 768px) {
    display: block;
    color: ${(props) => props.theme.colors.primary};
  }
`;

const SidebarLink = styled.a`
  color: ${(props) => props.theme.colors.light};
  text-decoration: none;
  padding: 10px;
  list-style-type: none; /* Remove bullets */
  cursor: pointer;
  line-height: 120%; /* 19.2px */
  font-size: 14px;
  @media (max-width: 768px) {
    color: ${(props) => props.theme.colors.primary};
  }
`;

const ToogleBtn = styled(TextButton)`
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.light};
  &:hover {
    color: ${(props) => props.theme.colors.primary};
  }
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);
  //const history = useHistory();
  //const { path } = history;

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      closeMenu();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // symptoms
  useEffect(() => {}, []);

  return (
    <>
      <MobileNavItem>
        <Sidebar ref={sidebarRef} isOpen={isOpen}>
          <ToogleBtn onClick={toggleMenu} type="button">
            <AiOutlineCloseCircle size={30} />
          </ToogleBtn>
          <SidebarLink href="/">
            Home 
            <SidebarLink></SidebarLink>
          </SidebarLink>
          <LinkwoUnderline to="/aboutus">
            <NavItem isOpen={isOpen}>About Us</NavItem>
          </LinkwoUnderline>
          <LinkwoUnderline to="/portfolio/gallery">
            <NavItem isOpen={isOpen}>Portfolio</NavItem>
          </LinkwoUnderline>
         { /*<LinkwoUnderline to="/">
            <NavItem isOpen={isOpen}>Mission Y Vision</NavItem>
          </LinkwoUnderline>*/}
          <LinkwoUnderline to="/contact">
            <NavItem isOpen={isOpen}>Contact Us</NavItem>
          </LinkwoUnderline>
          {/* */}
        </Sidebar>
      </MobileNavItem>
      <Nav className="col-12">
        <div className="col 12 pb-1 ps-3">
          <div className="d-flex align-items-center">
            <LinkwoUnderline to="/">
              <ImageIcon
                //src="/img/brand/logoArboleda.svg"
                src={logo}
                alt="logo construction"
                className="img-fluid"
                width={100}
              />
            </LinkwoUnderline>
          </div>
        </div>
        <MenuIcon onClick={toggleMenu} type="button">
          <FaBars size={25} />
        </MenuIcon>
        <LinkwoUnderline to="/">
        <NavItem>Home</NavItem>
        </LinkwoUnderline>
        <LinkwoUnderline to="/services">
        <NavItem>Services</NavItem>
        </LinkwoUnderline>
        <LinkwoUnderline to="/aboutus">
          <NavItem>About Us</NavItem>
        </LinkwoUnderline>
        <LinkwoUnderline to="/portfolio/gallery">
          <NavItem>Portfolio</NavItem>
        </LinkwoUnderline>
        {/*<LinkwoUnderline to="/mission#mission">
          <NavItem>Mission Vision</NavItem>
        </LinkwoUnderline>*/}
        <LinkwoUnderline to="/contact" className="ps-3">
          <NavItem>Contact Us</NavItem>
        </LinkwoUnderline>
      </Nav>
    </>
  );
};

export default Navbar;
